import React from 'react';
import PropTypes from 'prop-types';
import { intersection } from 'lodash';
import { mapProps } from 'recompose';

import { Image } from 'components/core/Image';

import visaImage from 'assets/images/credit-cards/visa.png';
import mastercardImage from 'assets/images/credit-cards/mastercard.png';
import amexImage from 'assets/images/credit-cards/amex.png';
import discoverImage from 'assets/images/credit-cards/discover.png';

const icons = {
	Visa: visaImage,
	Mastercard: mastercardImage,
	AMEX: amexImage,
	Discover: discoverImage,
};

// Filter out invalid cards
export const enhance = mapProps(({ cards }) => ({
	cards: intersection(cards, Object.keys(icons)),
}));

export function CreditCards({ cards }) {
	return (
		<div>
			{cards.map((card) => (
				<Image
					className="credit-card"
					key={card}
					src={icons[card]}
				/>
			))}
		</div>
	);
}

CreditCards.propTypes = {
	cards: PropTypes.arrayOf(PropTypes.oneOf(Object.keys(icons))).isRequired,
};

export default enhance(CreditCards);
